import React from 'react'

import chuapurict_building from "../images/Chuapukur Islamic Charitable Trust Hall.png";
function Aboutus() {
  return (
    <div>
       
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 style={{color:"#06AA00"}} className="card-title mb-0"><b>About us</b></h1>
                            <div className="col-md-2">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-7 mt-3">
                                        <div className='mission'>
                                            <h3 style={{ color: "#1D4D93" }} className='mb-2'>Welcome to <b>Chuapukur Islamic Charitable Trust </b></h3>
                                           <p style={{color:"#1D4D93"}} className='mb-2'>Dear Visitors,</p>
                                    
                                    <p className='justify mb-2'><b> CHUAPUKUR ISLAMIC CHARITABLE TRUST</b> is a registered non-profit organization dedicated to serving humanity with compassion, integrity, and social responsibility. Established in 2018 and registered under Regd. No. IV-1205-00043/2020, the Trust works with the primary objective of uplifting underprivileged communities through charitable, educational, and social welfare initiatives.</p>
                                    <p className='justify mb-1'>Rooted in Islamic values of humanity, equality, and service, the Trust believes in creating sustainable change by addressing fundamental needs such as education, healthcare, social support, and community development. Our activities are guided by the principle of serving people without discrimination of caste, creed, religion, or gender. </p>
                                    <p className='justify mb-1'>Over the years, Chuapukur Islamic Charitable Trust has been actively involved in supporting poor and needy individuals, promoting education among children, providing relief to distressed families, and contributing to social awareness and welfare programs. We strive to empower communities by encouraging self-reliance, moral development, and social harmony.</p>
                                    <p className='justify mb-3'>Our mission is to build a just and compassionate society where every individual has access to basic necessities, education, and dignity. With the support of well-wishers, donors, and volunteers, we continue to expand our efforts to make a meaningful and positive impact on society.</p>
                                    
                                    <h6 style={{color:"#1D4D93"}}>Warm regards,</h6>
                                    <h6 style={{color:"#1D4D93"}}>CHUAPUKUR ISLAMIC CHARITABLE TRUST</h6>
                                        </div>
                                    </div>
                                    <div className="col-md-5 mt-3">

                                        <img src={chuapurict_building} className="card-img-top" alt="chuapurict_building" />


                                    </div>





                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>
            <br />
    </div>
  )
}

export default Aboutus